import { render, staticRenderFns } from "./Canvas-Omni-Block-Grouping.vue?vue&type=template&id=be31eea8&"
import script from "./Canvas-Omni-Block-Grouping.vue?vue&type=script&lang=js&"
export * from "./Canvas-Omni-Block-Grouping.vue?vue&type=script&lang=js&"
import style0 from "./Canvas-Omni-Block-Grouping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports